import { Colors } from '@oy/uicore';
import classNames from 'classnames';
import React, { useContext } from 'react';
import { makeId } from '../../../utilities/idComponent';
import { Text } from '../../Contents';
import { DropdownContext } from './DropdownContext';
import styles from './DropdownMenuItem.module.css';

export enum DropdownMenuItemType {
  Primary = 'primary',
  Secondary = 'secondary',
  Destructive = 'destructive',
}

export type DropdownMenuItemProps = React.PropsWithChildren<{
  menuType?: DropdownMenuItemType;
}> &
  React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  >;

const DropdownMenuItem = ({
  menuType = DropdownMenuItemType.Primary,
  disabled,
  children,
  id,
  ...props
}: DropdownMenuItemProps) => {
  const { hideMenu } = useContext(DropdownContext);
  const classes = classNames(styles.menuItem, {
    [styles[menuType]]: !disabled,
    [styles.disabled]: disabled,
  });

  const textAttribute = () => {
    if (disabled) {
      return { style: Text.Style.BodyMdSemibold, color: Colors.BLACK40 };
    }

    switch (menuType) {
      case DropdownMenuItemType.Primary:
        return { style: Text.Style.BodyMdSemibold, color: Colors.BLUE100 };
      case DropdownMenuItemType.Secondary:
        return { style: Text.Style.BodyMdSemibold, color: Colors.BLACK100 };
      case DropdownMenuItemType.Destructive:
        return { style: Text.Style.BodyMdSemibold, color: Colors.RED100 };
      default:
        return { style: Text.Style.BodyMdSemibold, color: Colors.BLACK100 };
    }
  };

  return (
    <button
      className={classes}
      {...props}
      id={makeId('list', undefined, id)}
      disabled={disabled}
    >
      <Text
        textStyle={textAttribute().style}
        color={textAttribute().color}
        onClick={hideMenu}
      >
        {children}
      </Text>
    </button>
  );
};

export default DropdownMenuItem;
